export default {
   "name": "",
   "profile_photo_path": "",
   "email": "",
   "password": "",
   "icno": "",
   "contactno": "",
   "usertype": "",
   "status": "",
}
